import React from 'react';
import axios from 'axios';
import api from '../../../services/api';
import { Box, Typography, Card, CardContent, Button, CircularProgress, Alert } from '@mui/material';
import { useReporting } from '../ReportingContext';

const PlatformSettingsTab = () => {
  const {
    adsenseSuccess,
    adsensePingResult,
    adsensePingLoading,
    adsenseGlobalConnected,
    adsenseGlobalEmail,
    checkingAdsenseStatus,
    setAdsensePingResult,
    setAdsensePingLoading,
  } = useReporting();

  return (
  <Box>
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Global Identifiers & APIs
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Connect your Admin Google AdSense Account to automate revenue reporting across all affiliates.
            The server will save a background token so no one else has to log in.
          </Typography>
          {adsenseSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Global AdSense connection was successful! The token is saved securely.
            </Alert>
          )}

          {!checkingAdsenseStatus && adsenseGlobalConnected && !adsenseSuccess && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Global AdSense is already connected and live{adsenseGlobalEmail ? ` (${adsenseGlobalEmail})` : ''}.
            </Alert>
          )}

          <Button
            variant="contained"
            color="primary"
            disabled={adsenseGlobalConnected || checkingAdsenseStatus}
            onClick={async () => {
              try {
                const res = await api.get('/adsense/setup');
                if (res.data && res.data.setupUrl) {
                  window.location.href = res.data.setupUrl;
                }
              } catch (e) {
                alert('Failed to get setup URL');
              }
            }}
            sx={{ mr: 2 }}
          >
            {adsenseGlobalConnected ? 'Connected' : 'Connect Global AdSense Account'}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={async () => {
              setAdsensePingLoading(true);
              setAdsensePingResult(null);
              try {
                const res = await api.get('/adsense/revenue');
                setAdsensePingResult({ success: true, data: res.data });
              } catch (e) {
                setAdsensePingResult({ success: false, error: e.response?.data?.error || e.message });
              } finally {
                setAdsensePingLoading(false);
              }
            }}
            disabled={adsensePingLoading}
          >
            {adsensePingLoading ? <CircularProgress size={24} /> : 'Test AdSense API'}
          </Button>

          {adsensePingResult && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                API Test Result: {adsensePingResult.success ? '✅ Success' : '❌ Failed'}
              </Typography>
              <pre style={{ margin: 0, overflowX: 'auto', fontSize: '12px' }}>
                {JSON.stringify(adsensePingResult.data || adsensePingResult.error, null, 2)}
              </pre>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  </Box>

  );
};

export default PlatformSettingsTab;
